/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  realmDetailsInputContent: {
    paddingTop: theme.spacing(1),
    wordBreak: "break-word",
    display: "flex",
    alignItems: "center",
  },
  content: {
    marginRight: theme.spacing(1),
    wordBreak: "break-all",
  },
  valueContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "stretch",
    width: "90%",
  },
  pointer: {
    cursor: "pointer",
    size: "medium",
  },
  hide: {
    display: "none",
  },
  newUserValueContainer: {
    fontStyle: "italic",
  },
}));
